/* eslint-disable prettier/prettier */
import API_NEARCODE from './conf.js'
const nearcodeService = {
    async getJobs() {
        const response = await fetch(`${API_NEARCODE}jobs`, {
            method: "GET",
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error
        }
    },

    async addApplication(idJobs, name, email, cv, linkedin, skills, about, otherSkills, cellphone) {
        let formdata = new FormData()
        formdata.append('idJobs', idJobs)
        formdata.append('candidateName', name)
        formdata.append('candidateEmail', email)
        formdata.append('curriculum', cv)
        formdata.append('linkedin', linkedin)
        formdata.append('skills', JSON.stringify(skills))
        formdata.append('about', about)
        formdata.append('otherSkills', otherSkills)
        formdata.append('cellphone', cellphone)
        const response = await fetch(`${API_NEARCODE}applications`, {
            method: "POST",
            body: formdata
        })
        if (response.ok) {
            /* console.log(response.json()) */
            return response.json()
        } else {
            throw Error(response.json())
        }

    },

    async spontaneousApplication(name, email, cv, linkedin, skills, about, otherSkills, cellphone) {
        console.log(cellphone)
        let formdata = new FormData()
        formdata.append('candidateName', name)
        formdata.append('candidateEmail', email)
        formdata.append('curriculum', cv)
        formdata.append('linkedin', linkedin)
        formdata.append('skills', JSON.stringify(skills))
        formdata.append('about', about)
        formdata.append('otherSkills', otherSkills)
        formdata.append('cellphone', cellphone)
        const response = await fetch(`${API_NEARCODE}applications/spontaneous`, {
            method: "POST",
            body: formdata
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async getSkills() {
        const response = await fetch(`${API_NEARCODE}skills`, {
            method: "GET"
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error
        }
    },

    async getContent() {
        const response = await fetch(`${API_NEARCODE}content`, {
            method: "GET",
            headers: {
                'Content-type': 'application/json; charset=utd-8',
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },
    async sendEmail(name, email, message) {
        const response = await fetch(`${API_NEARCODE}contact/email`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify({
                name: name,
                email: email,
                message: message,
            })
        })
        console.log(response)
        if (response.ok) {
            return response.text()
        } else {
            throw Error(await response.json())
        }
    }
}
export default nearcodeService